export const LOGIN_REQUEST = "LOGIN_REQUEST";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAILURE = "LOGIN_FAILURE";

export const AUDIT_LOGIN__REQUEST = "AUDIT_LOGIN__REQUEST";
export const AUDIT_LOGIN__SUCCESS = "AUDIT_LOGIN__SUCCESS";
export const AUDIT_LOGIN__FAILURE = "AUDIT_LOGIN__FAILURE";

export const CLEAR_ERRORS = "CLEAR_ERRORS";
